<template>
  <view>
    <create-order :orderData="orderForm" />
  </view>
</template>

<script>
import CreateOrder from '@/components/order/CreateOrder';
export default {
  name: 'newOrder',
  components: {
    CreateOrder,
  },
  data() {
    return {
      orderForm: null,
      orderFormOriginal: null,
    };
  },
  onLoad(query) {
    console.log('%c [参数]: ', 'color:#1989fa;', JSON.parse(query.orderForm));
    this.orderForm = JSON.parse(query.orderForm);
    // this.orderFormOriginal = JSON.parse(query.orderForm);
  },
};
</script>

<style scoped></style>
